import { useState } from "react";
import { useEffect } from "react";

const CAPABILITY_SET = {
  capabilityadvanced: "advanced",
  capabilityAdvanced: "advanced",
  capabilitystandard: "standard",
  capabilityStandard: "standard",
};

export const useCapabilitySet = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [capabilitySet, setCapabilitySet] = useState("standard");
  const [isOrgAdmin, setIsOrgAdmin] = useState(false);

  useEffect(() => {
    if (window.AP) {
      setIsLoading(true);
      window.AP.request("/rest/api/user/current?expand=operations").then(
        (res) => {
          const user = JSON.parse(res.body);
          setIsOrgAdmin(
            user.operations.some(
              (o) =>
                o.operation === "administer" && o.targetType === "application"
            )
          );
        }
      );

      window.AP.context.getContext((response) => {
        setCapabilitySet(
          CAPABILITY_SET[response?.license?.capabilitySet] || "standard"
        );
        setIsLoading(false);
      });
    }
  }, []);

  return {
    isLoading,
    capabilitySet,
    isOrgAdmin,
  };
};
